import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { AuthProvider } from "./auth/AuthContext";
import "./index.css";

// Canonical host is albinsson.ai. If someone lands on the legacy
// randes-search.albinsson.ai, redirect them to the equivalent path on the
// apex domain so old bookmarks keep working.
if (window.location.hostname === "randes-search.albinsson.ai") {
  const target =
    "https://albinsson.ai" +
    window.location.pathname +
    window.location.search +
    window.location.hash;
  window.location.replace(target);
} else {
  ReactDOM.createRoot(document.getElementById("root")!).render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider>
          <App />
        </AuthProvider>
      </BrowserRouter>
    </React.StrictMode>,
  );
}
